import { Label } from '../models/project.model';

// Should this come from the backend???
export const DEFAULT_LABELS: Label[] = [
    {
        name: 'Temporary',
        icon: 'box-select'
    },
    {
        name: 'Permanent',
        icon: 'brick-wall'
    },
    {
        name: 'Kill-switch',
        icon: 'bug-off'
    },
    {
        name: 'Feature',
        icon: 'star'
    }
];
